import { GoogleAnalyticsConnectionType } from '@/types/Connectors';
import { GetHandleInvitationLinkData } from '@/types/Firestore';
import {
  InvitationFromStore,
  PermissionFromStore,
  UserRole,
  userRoles,
} from '@/types/types';
import { FirebaseError } from 'firebase/app';
import { has } from 'lodash';

export const isUserRole = (role: string | null | undefined): role is UserRole => {
  if (typeof role !== 'string') return false;
  return userRoles.includes(role as UserRole);
};

export const isPermission = (permission: object): permission is PermissionFromStore => {
  return (
    has(permission, 'role') &&
    has(permission, 'addedBy') &&
    has(permission, 'email') &&
    has(permission, 'createdAt') &&
    has(permission, 'organizationId')
  );
};

export function isInvitation<T extends 'workspace' | 'organization'>(
  invitation: object,
): invitation is InvitationFromStore<T> {
  return (
    Object.hasOwn(invitation, 'id') &&
    Object.hasOwn(invitation, 'invitedUserEmail') &&
    Object.hasOwn(invitation, 'createdAt') &&
    Object.hasOwn(invitation, 'invitedUserId') &&
    Object.hasOwn(invitation, 'invitingUserEmail') &&
    Object.hasOwn(invitation, 'invitingUserId') &&
    Object.hasOwn(invitation, 'hash') &&
    Object.hasOwn(invitation, 'organizationName') &&
    Object.hasOwn(invitation, 'expirationDate') &&
    Object.hasOwn(invitation, 'role') &&
    Object.hasOwn(invitation, 'organizationId')
  );
}

export function isGoogleAnalyticsConnectionType(
  type: string,
): type is GoogleAnalyticsConnectionType {
  return type === 'oauth' || type === 'manual';
}

export function isWorkspaceInvitation(
  invitation: unknown,
): invitation is GetHandleInvitationLinkData {
  return (
    typeof invitation === 'object' &&
    !!invitation &&
    Object.hasOwn(invitation, 'workspaceName')
  );
}

export function isOrganizationInvitation(
  inv: unknown,
): inv is Pick<GetHandleInvitationLinkData, 'organizationName'> {
  return typeof inv === 'object' && !!inv && Object.hasOwn(inv, 'organizationName');
}

export function isFirebaseError(error: unknown): error is FirebaseError {
  return (
    typeof error === 'object' &&
    !!error &&
    Object.hasOwn(error, 'code') &&
    Object.hasOwn(error, 'message')
  );
}
